enum ModalType {
  CONSULT = "consult",
  UPDATE = "update",
  SCHEDULE = "schedule",
  DEMARCATE = "demarcate",
  UPDATE_USER = "update-user",
  NONE = "",
}
export default ModalType;
